/* global analytics */
import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import Login from './views/Login.vue';
import PasswordForgotten from './views/PasswordForgotten.vue';
import PasswordEdit from './views/PasswordEdit.vue';
import Opportunities from './views/Opportunities.vue';
import OpportunityShow from './views/OpportunityShow.vue';
import OpportunitySummary from './views/OpportunitySummary.vue';
import OpportunityOperation from './views/OpportunityOperation.vue';
import OpportunityAccept from './views/OpportunityAccept.vue';
import InvestmentEntityChoice from './views/InvestmentEntityChoice.vue';
import InvestmentEntityKindChoice from './views/InvestmentEntityKindChoice.vue';
import InvestmentEntityConfirmation from './views/InvestmentEntityConfirmation.vue';
import InvestmentEntityCompanyCreation from './views/InvestmentEntityCompanyCreation.vue';
import InvestmentEntityPersonCreation from './views/InvestmentEntityPersonCreation.vue';
import InvestmentDetails from './views/InvestmentDetails.vue';
import KeralaAnalysis from './views/KeralaAnalysis.vue';
import ManagementReport from './views/ManagementReport.vue';
import Investments from './views/Investments.vue';
import InvestmentShow from './views/InvestmentShow.vue';
import InvestmentSummary from './views/InvestmentSummary.vue';
import InvestmentReporting from './views/InvestmentReporting.vue';
import InvestmentDocuments from './views/InvestmentDocuments.vue';
import WishForm from './views/WishForm.vue';
import WishValidation from './views/WishValidation.vue';
import WishConfirmation from './views/WishConfirmation.vue';
import WishDecline from './views/WishDecline.vue';
import Profile from './views/Profile.vue';
import PageNotFound from './views/PageNotFound.vue';
import KycIntroduction from './views/kyc/Introduction.vue';
import KycJob from './views/kyc/Job.vue';
import KycTaxResidence from './views/kyc/TaxResidence.vue';
import KycMaritalStatus from './views/kyc/MaritalStatus.vue';
import KycSpouse from './views/kyc/Spouse.vue';
import KycMarriageType from './views/kyc/MarriageType.vue';
import KycChildren from './views/kyc/Children.vue';
import KycChildrenDetails from './views/kyc/ChildrenDetails.vue';
import KycPpe from './views/kyc/Ppe.vue';
import KycFinancial from './views/kyc/Financial.vue';
import KycCash from './views/kyc/Cash.vue';
import KycProperty from './views/kyc/Property.vue';
import KycVentureCapital from './views/kyc/VentureCapital.vue';
import KycOtherInvestments from './views/kyc/OtherInvestments.vue';
import KycSalary from './views/kyc/Salary.vue';
import KycDebts from './views/kyc/Debts.vue';
import KycKnowledgeQuestions from './views/kyc/KnowledgeQuestions.vue';
import KycGoalQuestions from './views/kyc/GoalQuestions.vue';
import KycAttachments from './views/kyc/Attachments.vue';
import KycDesktopIntroduction from './views/kyc/desktop/Introduction.vue';
import KycDesktopIdentity from './views/kyc/desktop/Identity.vue';
import KycDesktopFinancialIntroduction from './views/kyc/desktop/FinancialIntroduction.vue';
import KycDesktopFinancial from './views/kyc/desktop/Financial.vue';
import KycDesktopKnowledge from './views/kyc/desktop/KnowledgeQuestions.vue';
import KycDesktopGoal from './views/kyc/desktop/GoalQuestions.vue';
import KycDesktopAttachments from './views/kyc/desktop/Attachments.vue';
import KycDesktopSuccess from './views/kyc/desktop/Success.vue';
import KycSuccess from './views/kyc/Success.vue';
import LegalNotice from './views/LegalNotice.vue';
import KycValidation from './views/kyc/Validation.vue';
import KycSigned from './views/kyc/Signed.vue';
import store from './store/store';
import { SET_ALERT } from './store/mutation-types';

Vue.use(Router);
Vue.use(Meta);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      meta: {
        public: true,
      },
    },
    {
      path: '/password-forgotten',
      name: 'Password forgotten',
      component: PasswordForgotten,
      meta: {
        public: true,
      },
    },
    {
      path: '/password-edit',
      name: 'Password edit form',
      component: PasswordEdit,
      meta: {
        public: true,
      },
    },
    {
      path: '/opportunities',
      name: 'Opportunities list',
      component: Opportunities,
    },
    {
      path: '/opportunities/:id',
      name: 'Opportunity show',
      component: OpportunityShow,
    },
    {
      path: '/opportunities/:id/summary',
      component: OpportunitySummary,
      name: 'Opportunity summary',
    },
    {
      path: '/opportunities/:id/operation-details',
      component: OpportunityOperation,
      name: 'Opportunity operation details',
    },
    {
      path: '/opportunities/:id/kerala-analysis',
      component: KeralaAnalysis,
      name: 'Kerala Analysis',
    },
    {
      path: '/opportunities/:id/management-report',
      component: ManagementReport,
      name: 'Management report',
    },
    {
      path: '/opportunities/:id/accept',
      component: OpportunityAccept,
      name: 'Opportunity accept form',
    },
    {
      path: '/opportunities/:id/investment-entities',
      component: InvestmentEntityChoice,
      name: 'Investment entity choice',
    },
    {
      path: '/investment-entities/new',
      component: InvestmentEntityKindChoice,
      name: 'Investment entity kind choice',
    },
    {
      path: '/investment-entities/Company/:investmentEntityId/edit',
      component: InvestmentEntityCompanyCreation,
      name: 'Investment entity company edit',
    },
    {
      path: '/investment-entities/Person/:investmentEntityId/edit',
      component: InvestmentEntityPersonCreation,
      name: 'Investment entity person edit',
    },
    {
      path: '/investment-entities',
      redirect: '/profile',
    },
    {
      path: '/opportunities/:id/investment-entities/new',
      component: InvestmentEntityKindChoice,
      name: 'Opportunity Investment entity kind choice',
    },
    {
      path: '/opportunities/:id/investment-entities/confirmation',
      component: InvestmentEntityConfirmation,
      name: 'Investment entity confirmation',
    },
    {
      path: '/investment-entities/new/company',
      component: InvestmentEntityCompanyCreation,
      name: 'Opportunity Investment entity company form',
    },
    {
      path: '/investment-entities/new/person',
      component: InvestmentEntityPersonCreation,
      name: 'Opportunity Investment entity person form',
    },
    {
      path: '/opportunities/:id/investment-entities/new/company',
      component: InvestmentEntityCompanyCreation,
      name: 'Investment entity company form',
    },
    {
      path: '/opportunities/:id/investment-entities/new/person',
      component: InvestmentEntityPersonCreation,
      name: 'Investment entity person form',
    },
    {
      path: '/opportunities/:id/wish/new',
      component: WishForm,
      name: 'Wish amount form',
    },
    {
      path: '/opportunities/:id/wish/validation',
      component: WishValidation,
      name: 'Wish validation',
    },
    {
      path: '/opportunities/:id/wish/confirmation',
      component: WishConfirmation,
      name: 'Wish confirmation',
    },
    {
      path: '/opportunities/:id/wish/decline',
      component: WishDecline,
      name: 'Wish decline form',
    },
    {
      path: '/investments',
      component: Investments,
      name: 'Investment list',
    },
    {
      path: '/investments/:id',
      component: InvestmentShow,
      name: 'Investment show',
    },
    {
      path: '/investments/:id/summary',
      name: 'Investment summary',
      component: InvestmentSummary,
    },
    {
      path: '/investments/:id/details',
      name: 'Investment details',
      component: InvestmentDetails,
    },
    {
      path: '/investments/:id/reporting',
      name: 'Investment reporting',
      component: InvestmentReporting,
    },
    {
      path: '/investments/:id/documents',
      name: 'Investment documents',
      component: InvestmentDocuments,
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
    },
    {
      path: '/kyc/introduction',
      name: 'KycIntroduction',
      component: KycIntroduction,
    },
    {
      path: '/kyc/job',
      name: 'KycJob',
      component: KycJob,
    },
    {
      path: '/kyc/tax-residence',
      name: 'KycTaxResidence',
      component: KycTaxResidence,
    },
    {
      path: '/kyc/marital-status',
      name: 'KycMaritalStatus',
      component: KycMaritalStatus,
    },
    {
      path: '/kyc/spouse',
      name: 'KycSpouse',
      component: KycSpouse,
    },
    {
      path: '/kyc/marriage-type',
      name: 'KycMarriageType',
      component: KycMarriageType,
    },
    {
      path: '/kyc/children',
      name: 'KycChildren',
      component: KycChildren,
    },
    {
      path: '/kyc/children-details',
      name: 'KycChildrenDetails',
      component: KycChildrenDetails,
    },
    {
      path: '/kyc/ppe',
      name: 'KycPpe',
      component: KycPpe,
    },
    {
      path: '/kyc/financial',
      name: 'KycFinancial',
      component: KycFinancial,
    },
    {
      path: '/kyc/cash',
      name: 'KycCash',
      component: KycCash,
    },
    {
      path: '/kyc/property',
      name: 'KycProperty',
      component: KycProperty,
    },
    {
      path: '/kyc/venture-capital',
      name: 'KycVentureCapital',
      component: KycVentureCapital,
    },
    {
      path: '/kyc/other-investments',
      name: 'KycOtherInvestments',
      component: KycOtherInvestments,
    },
    {
      path: '/kyc/salary',
      name: 'KycSalary',
      component: KycSalary,
    },
    {
      path: '/kyc/debts',
      name: 'KycDebts',
      component: KycDebts,
    },
    {
      path: '/kyc/knowledge/:id',
      name: 'KycKnowledgeQuestions',
      component: KycKnowledgeQuestions,
    },
    {
      path: '/kyc/goal/:id',
      name: 'KycGoalQuestions',
      component: KycGoalQuestions,
    },
    {
      path: '/kyc/attachments',
      name: 'KycAttachments',
      component: KycAttachments,
    },
    {
      path: '/legal-notice',
      name: 'LegalNotice',
      component: LegalNotice,
    },
    {
      path: '/kyc/desktop/identity',
      component: KycDesktopIdentity,
      name: 'KycDesktopIdentity',
    },
    {
      path: '/kyc/desktop/introduction',
      component: KycDesktopIntroduction,
      name: 'KycDesktopIntroduction',
    },
    {
      path: '/kyc/desktop/financial/introduction',
      component: KycDesktopFinancialIntroduction,
      name: 'KycDesktopFinancialIntroduction',
    },
    {
      path: '/kyc/desktop/financial',
      component: KycDesktopFinancial,
      name: 'KycDesktopFinancial',
    },
    {
      path: '/kyc/desktop/knowledge',
      component: KycDesktopKnowledge,
      name: 'KycDesktopKnowledge',
    },
    {
      path: '/kyc/desktop/goal',
      component: KycDesktopGoal,
      name: 'KycDesktopGoal',
    },
    {
      path: '/kyc/desktop/attachments',
      component: KycDesktopAttachments,
      name: 'KycDesktopAttachments',
    },
    {
      path: '/kyc/success',
      name: 'KycSuccess',
      component: KycSuccess,
    },
    {
      path: '/kyc/desktop/success',
      name: 'KycDesktopSuccess',
      component: KycDesktopSuccess,
    },
    {
      path: '/kyc/validate',
      name: 'KycValidation',
      component: KycValidation,
    },
    {
      path: '/kyc/signed',
      name: 'KycSigned',
      component: KycSigned,
    },
    {
      path: '/kyc',
      redirect: () => {
        if (window.screen.width > 768) {
          return '/kyc/desktop/introduction';
        }
        return '/kyc/introduction';
      },
    },
    {
      path: '*',
      component: PageNotFound,
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.afterEach((to, from) => {
  analytics.page(to.name);
  if (from.name) {
    router.lastPath = from.name;
  }
  store.commit(SET_ALERT, null);
});

export default router;
